var animationModule = function ($) {

    var elementsToAnimate;

    function animate(items, trigger) {
        items.each(function () {
            var $elem = $(this),
                elemAnimType = $elem.attr('data-animation-type'),
                elemAnimDuration = $elem.attr('data-animation-duration'),
                elemAnimDelay = $elem.attr('data-animation-delay'),
                $triggerElem = (trigger) ? trigger : $elem;

            $elem.css({
                '-webkit-animation-delay': elemAnimDelay,
                '-moz-animation-delay': elemAnimDelay,
                'animation-delay': elemAnimDelay
            });

            $elem.css({
                '-webkit-animation-duration': elemAnimDuration,
                '-moz-animation-duration': elemAnimDuration,
                'animation-duration': elemAnimDuration
            });

            $triggerElem.waypoint(function () {
                $elem.addClass('animated').addClass(elemAnimType);
                $triggerElem.addClass('in-view');
            }, {
                triggerOnce: true,
                offset: '90%'
            });
        });
    }

    function init() {

        elementsToAnimate = $('.js-animate-container');

        if (elementsToAnimate.length > 0) {
            elementsToAnimate.each(function(index,elem) {
                var $animationContainer = $(elem),
                    $animationItems = $animationContainer.find('.js-animate');

                animate($animationItems, $animationContainer);
            });
        }
    }

    return {
        init: init
    };

}(jQuery);

$(function(){
    animationModule.init();
});
